import { create } from 'zustand';
interface LoadingStore {
  isCreateLoading: boolean;
  setCreateLoading: (newLoading: boolean) => void;
}

export const useCreateRoomRatesStore = create<LoadingStore>((set) => ({
  isCreateLoading: false,
  setCreateLoading: (newLoading: boolean) => set({ isCreateLoading: newLoading })
}));
